import { useState } from 'react';

export function useModal(initial = false) {
  const [isOpen, setIsOpen] = useState(initial);
  const open = () => {
    setIsOpen(true);
  };
  const dismiss = () => {
    setIsOpen(false);
  };

  return {
    dismiss,
    isOpen,
    open,
  };
}
